export default __webpack_public_path__ + "static/media/fog-night.1f12d184.svg";